import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import styles from './DesignerTeaser.module.scss';
import { withBreakpoints } from 'react-breakpoints';
import { useLocale } from 'src/modules/locale';
import { Row, Col } from 'antd';
import { GlobalImage, IconImage, GlobalIcon } from '../..';
import { DesignerEntity } from 'src/modules/designers';
import { useIntl } from 'react-intl';
import Link from 'next/link';
import { defaultHorizontalGutter } from 'src/utils/grid';

export interface DesignerTeaserProps {
  designer: DesignerEntity;
  currentBreakpoint: string;
}

const DesignerTeaser = (props: DesignerTeaserProps) => {
  const { getLocalizedObject } = useLocale();
  const intl = useIntl();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  if (!mounted) return null;
  if (!props.designer) return null;

  const { assets = [], description, slug } = getLocalizedObject(props.designer);
  const currentBreakpoint = props.currentBreakpoint;

  const imageJsx = <GlobalImage className={styles.image} url={assets[0]?.file?.url} />;

  const titleJsx = (
    <h3 className={styles.title}>{`${intl.formatMessage({
      id: 'page/products/details/design_prefix',
    })}: ${props.designer?.name}.`}</h3>
  );

  const descriptionJsx = (
    <>
      {description && (
        <p className={styles.body} dangerouslySetInnerHTML={{ __html: description }} />
      )}
      <Link href="/designers/[slug]" as={`/designers/${slug}`}>
        <a>
          {intl.formatMessage({ id: 'page/products/details/designer_teaser_button' })}
          <GlobalIcon image={IconImage.RightArrow} className={styles.rightArrow} size="custom" />
        </a>
      </Link>
    </>
  );

  if (_.includes(['xs', 'sm'], currentBreakpoint))
    return (
      <Row className={styles.container}>
        <Col span={24}>{titleJsx}</Col>
        <Col span={24}>{imageJsx}</Col>
        <Col span={24}>{descriptionJsx}</Col>
      </Row>
    );

  return (
    <Row gutter={[defaultHorizontalGutter, 0]} className={styles.container}>
      <Col span={10} offset={2}>
        {imageJsx}
      </Col>
      <Col span={8} offset={2}>
        {titleJsx}
        {descriptionJsx}
      </Col>
    </Row>
  );
};

export default withBreakpoints(DesignerTeaser);
